import { useSlbcContext } from '../hooks/useSlbcContext'

// date fns
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const MainSlideDetails = ({ mainSlide }) => {
  const { dispatch } = useSlbcContext()

  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    confirmAlert({
      title: 'Confirm to submit',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => deleteMainSlide(mainSlide)
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  }

  const deleteMainSlide =  async(mainSlide) => {
    setLoading(true);

    const response = await fetch('/api/main_slides/' + mainSlide._id, {
      method: 'DELETE'
    })
    const json = await response.json()

    if (response.ok) {
      dispatch({type: 'DELETE_MAIN_SLIDE', payload: json})
      setLoading(false);
    }
  }

  return (
    <div className="workout-details slide-item">
      <img className="activator" src={'/main_slides/'+mainSlide._id+'.png'} alt={mainSlide.title}/>
      
      <div className='channel-info'>
        <h4>{mainSlide.title}</h4>
        <p><strong>Link: </strong>{mainSlide.link}</p>
        <p>{formatDistanceToNow(new Date(mainSlide.createdAt), { addSuffix: true })}</p>
        {!loading && <span className="material-symbols-outlined" onClick={handleClick}>delete</span>}
        {loading && <span className="material-symbols-outlined"><FontAwesomeIcon className="material-symbols-outlined" icon={icon({name: 'spinner'})} spin/></span>}
      </div>
    </div>
  )
}

export default MainSlideDetails